import axios from "axios";

const apiClient = axios.create({
  baseURL: "/wp-json",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export default {
  getFeed(endpoint, args = {}) {
    return apiClient.get("/uom/v1/" + endpoint, args);
  },
  getFeatured(args = {}) {
    return apiClient.get("/uom/v1/featured", args);
  },
  getTaxonomy(taxonomy, args = {}) {
    return apiClient.get("/wp/v2/" + taxonomy, args);
  },
  getTaxonomies(args = {}) {
    return apiClient.get("/uom/v1/taxonomies", args);
  },
};
